/* eslint-disable max-len */
/* eslint-disable sort-keys-fix/sort-keys-fix */
export const tableMessages = {
    'Table.filter.header': '$t({{columnHeaderKey}}) Filter',
    'Table.filters.clear': 'Clear Filters',
    // filtering translations
    'Table.filter.riskFilter.Critical': '<WarningTriangleFilledIcon/> Critical',
    'Table.filter.riskFilter.High': '<WarningIcon/> High',
    'Table.filter.riskFilter.Medium': '<BrightnessIcon/> Medium',
    'Table.filter.riskFilter.Low': '<CheckIcon/> Low',
    'Table.filter.riskFilter.Alert': '<NotificationIcon/> Alert',
    'Table.filter.riskFilter.Safe': '<ValidUserIcon/> Safe',
    'Table.filter.licenseData.available': '<CheckCircleIcon/> Available',
    'Table.filter.licenseData.notConnected': '<BanCircleIcon/> Not Connected',
    'Table.filter.licenseData.syncFailed': '<WarningTriangleIcon/> Sync Failed',
    'Table.filter.licenseData.unavailable': 'Unavailable',

    'Table.filter.MAC': '<AppleIcon/> MacOS',
    'Table.filter.WINDOWS': '<WindowsIcon/> Windows',
    'Table.filter.LINUX': '<LinuxIcon/> Linux',
    'Table.filter.ANDROID': '<AndroidIcon/> Android',
    'Table.filter.IOS': '<AppleIcon/> iOS',

    'Table.filter.last24hours': 'Last 24 hours',
    'Table.filter.last3days': 'Last 3 days',
    'Table.filter.last7days': 'Last 7 days',
    'Table.filter.last14days': 'Last 14 days',
    'Table.filter.last30days': 'Last 30 days',
    'Table.filter.last90days': 'Last 90 days',

    'Table.filter.never': 'Never',
    'Table.filter.over30days': 'Over 30 days',
    'Table.filter.over90days': 'Over 90 days',
    'Table.filter.overAYear': 'Over a year',

    'Table.filter.lastLoginTimeOver30daysAgo.over30days':
        '<ClockIcon/> Last login was more than 30 days ago.',

    'Table.filter.noUsers': 'None',
    'Table.filter.oneUser': 'One user',
    'Table.filter.threeOrMore': 'Three or more users',
    'Table.filter.twoUsers': 'Two users',

    'Table.filter.brave.com': '<BraveIcon/> Brave',
    'Table.filter.chrome.com': '<ChromeIcon/> Chrome',
    'Table.filter.fas-chrome.com': '<ChromeIcon/> Chrome Alt',
    'Table.filter.microsoftedge.exe': '<EdgeIcon/> Edge',
    'Table.filter.microsoftedgewelcome.microsoft.com':
        '<EdgeIcon/> Edge Chromium',
    'Table.filter.firefox.com': '<FirefoxIcon/> Firefox',
    'Table.filter.www.opera.com': '<OperaIcon/> Opera',
    'Table.filter.safari': '<SafariIcon/> Safari',
    'Table.filter.not-data': 'Not identified',
    'Table.filter.Null': 'None',

    'Table.filter.ssoCoverage.availableNotInUse': 'Available - Not in use',
    'Table.filter.ssoCoverage.availableNotInUse.tooltip':
        'Apps that match this filter provide an opportunity to improve your security posture by adding them to your SSO Provider.',

    'Table.filter.ssoCoverage.atLeastOneInUse': 'At least one SSO detected',
    'Table.filter.ssoCoverage.unavailable': 'Unavailable',

    'Table.filter.source.categories.group': 'Application Categories',
    'Table.filter.source.webActivity.group': 'Browser',
    'Table.filter.source.integrationsActivity.group': 'Integrations',
    'Table.filter.source.ssoActivity.group': 'SSO',

    'Table.filter.source.desktop': '<LaptopIcon/> Desktop Activity',
    'Table.filter.source.webActivity': '<CloudIcon/> Web Activity',
    'Table.filter.source.webLogin': '<VpnLockIcon/> Form Login',
    'Table.filter.source.download': '<CloudDownloadIcon/> Download Activity',
    'Table.filter.source.microsoftSSO': '<MicrosoftIcon/> Microsoft SSO',
    'Table.filter.source.googleSSO': '<GoogleIcon/> Google SSO',
    'Table.filter.source.quickScan': '<ClockIcon/> Browser History',
    'Table.filter.source.azure': '<WindowsIcon/> Microsoft Entra ID Login',
    'Table.filter.source.google': '<GWSIcon/> GWS Login',

    'Table.filter.classified.true': 'Classified',
    'Table.filter.classified.false': 'Unclassified',

    'Table.filter.status.unapproved': '<WarningIcon/> Unapproved',
    'Table.filter.status.not_configured': '<QuestionMarkIcon/> Not configured',
    'Table.filter.status.evaluating': '<SeverityInformationalIcon/> Evaluating',
    'Table.filter.status.implementing': '<AddCircleIcon/> Implementing',
    'Table.filter.status.approved': '<CheckIcon/> Approved',
    'Table.filter.status.decommissioning':
        '<SubtractCircleIcon/> Decommissioning',
    'Table.filter.status.decommissioned': '<CloseCircleIcon/> Decommissioned',
    'Table.filter.businessOwnerType.managedByPartner':
        '<GroupCircleIcon/> Apps Managed By Partner',
    'Table.filter.businessOwnerType.managedByPartner.tooltip':
        'Your organization manages this application on behalf of the customer/site. These are applications you support across the entire base.',
    'Table.filter.businessOwnerType.managed3rdParty':
        '<BlurCircularIcon/> Managed By 3rd Party',
    'Table.filter.businessOwnerType.managed3rdParty.tooltip':
        'Your organization does not manage this application on behalf of the customer, the customer does not manage it, and a third party group is in charge of management.',
    'Table.filter.businessOwnerType.noBusinessOwnerRequired':
        '<CheckCircleIcon/> No Business Owner Required',
    'Table.filter.businessOwnerType.noBusinessOwnerRequired.tooltip':
        'No one manages it or it is a self-managed application by the employees using the resources (such as a web portal, etc.)',
    'Table.filter.businessOwnerType.notAssigned':
        '<CloseCircleIcon/> Not Assigned',

    'Table.filter.managementStage.managedApplication': 'Managed',
    'Table.filter.managementStage.unmanagedApplication': 'Unmanaged'
};
